import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FormPage from './pages/FormPage';
import ThankYouPage from './pages/ThankYouPage';
import ErrorPage from './pages/ErrorPage';
import ErrorTimePage from './pages/ErrorTimePage';
import LandingPage from './pages/landingPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FormPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/error-time" element={<ErrorTimePage />} />
        <Route path="/lp" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;